import React, { useEffect, useState } from 'react'
import '../styles/cookieConsent.css'
import {
  COOKIE_CONSENT_EVENT,
  getCookieConsentChoice,
  setCookieConsentChoice,
} from '../utils/cookieConsent'

function CookieConsentBanner() {
  const [isOpen, setIsOpen] = useState(() => !getCookieConsentChoice())

  useEffect(() => {
    const handleConsentChange = (event) => {
      const nextChoice = event?.detail?.choice ?? getCookieConsentChoice()
      setIsOpen(!nextChoice)
    }

    window.addEventListener(COOKIE_CONSENT_EVENT, handleConsentChange)
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handleConsentChange)
  }, [])

  const handleDismiss = () => {
    setCookieConsentChoice('dismissed')
    setIsOpen(false)
  }

  return (
    <>
      {isOpen && (
        <div className="cookie-consent-banner" role="dialog" aria-live="polite" aria-label="Cookie consent">
          <div className="cookie-consent-copy">
            <span className="cookie-consent-eyebrow">Privacy settings</span>
            <h3>Anonymous audience measurement is active</h3>
            <p>
              We use privacy-preserving measurement to count page visits by route and day. We do not
              store IP addresses, user agents, session identifiers, referrers or location data in our
              monitoring database. This notice explains how visit counting works on the site.
            </p>
            <div className="cookie-consent-summary">
              <div className="cookie-consent-summary-item required">
                <span className="cookie-consent-summary-label">Necessary</span>
                <span className="cookie-consent-summary-value">Preference storage only</span>
              </div>
              <div className="cookie-consent-summary-item optional">
                <span className="cookie-consent-summary-label">Audience measurement</span>
                <span className="cookie-consent-summary-value">Anonymous page and day counts only</span>
              </div>
            </div>
          </div>
          <div className="cookie-consent-actions">
            <button type="button" className="cookie-consent-btn primary" onClick={handleDismiss}>
              Understood
            </button>
          </div>
        </div>
      )}
    </>
  )
}

export default CookieConsentBanner
